import { Component, Prop, h } from '@stencil/core';

const COMPONENT_NAME = 'popup-banner-type-2';

/**
 * Compact horizontal banner strip with action buttons and configurable alignment.
 * Displays text content via prop with action buttons in a minimal-padding section.
 * Used for promotional announcements or alerts at the top or bottom of a page.
 *
 * @category Popups
 * @slot actions - Container for action buttons (1-5 buttons, <me-button variant='tertiary' size='sm'>)
 * @example
 *   <popup-banner-type-2 text="Limited time offer: Get 30% off all plans!">
 *     <me-button slot="actions" variant="tertiary" size="sm">Claim Offer</me-button>
 *   </popup-banner-type-2>
 */

@Component({
  tag: 'popup-banner-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class PopupBannerType2 {
  /**
   * Horizontal content alignment inside the banner: 'left', 'center', or 'right'
   * @default 'end'
   */
  @Prop() align: 'start' | 'center' | 'end' = 'end';

  render() {
    return (
      <me-section class={COMPONENT_NAME} yGap="2xs" yGapLg="2xs">
        <me-row xGap="none" xGapLg="none" yGap="none" yGapLg="none" justify={`${this.align}`} justifyLg={`${this.align}`}>
          <me-column span="auto">
            <div class={`${COMPONENT_NAME}__actions`}>
              <slot name="actions"></slot>
            </div>
          </me-column>
        </me-row>
      </me-section>
    );
  }
}
